import type { TMessages } from '@/types/TMessages'

export const messages = {
  form: {
    phone: {
      placeholder: 'Номер телефона',
      errors: {
        required: 'Необходимо заполнить',
      },
    },
    submit: 'Получить консультацию',
  },
} satisfies TMessages
